import { IMenuApiModel } from '@official/models/menu-api.model';
import { RouteNamesEnum } from '@official/routes/routes';
import { IHeaderModel } from '@types-custom/models/ui/header.model';
import { Icon, getIcon } from '@types-custom/models/ui/icon-model';
import { ActionType, IMenuEvent, IMenuModel } from '@types-custom/models/ui/menu.model';
import { BehaviorSubject, map } from 'rxjs';
import { MenuEventType } from '@shared/models/menu-event-type.model';
import { IRole } from '@shared/models/user.model';
import { modals } from '@shared/utils/mappers/modal';
import { ModalType } from '@shared/models/modal-type';
import { MapLayers } from "@shared/utils/mappers/layers-map.model";
import { NotificationMenuComponent } from '@ui-core/components/header/notification-menu/notification-menu.component';


function apiRoute(apiUrl: string): ActionType {
  const Routes: string[] = [
    RouteNamesEnum.UserManagement,
    RouteNamesEnum.ManageAlerts,
    RouteNamesEnum.RolesManagement,
    RouteNamesEnum.ManageAudit,
    RouteNamesEnum.ManageSensor,
    RouteNamesEnum.BlackWhiteLists,
  ]
  return Routes.includes(apiUrl) ? ActionType.Route : ActionType.Panel;
}

const menuAPIToMenu = (
  menuApi: IMenuApiModel,
  dispatcher?: BehaviorSubject<any>
): IMenuModel<any> => {
  return {
    action: menuApi.url,
    dispatcher: dispatcher,
    text: menuApi.name,
    alt: menuApi.name,
    isVisible: true,
    icon: getIcon()[menuApi.icon],
    returnPanel: apiRoute(menuApi.url) !== ActionType.Route,
    actionPanel: RouteNamesEnum.MapViewer,
    actionType: apiRoute(menuApi.url),
  };
};

const generateSubmenus = (
  apiMenuList: IMenuApiModel[],
  dispatcher: BehaviorSubject<any>
): IMenuModel<any>[] => {
  const mainMenus = apiMenuList.map((menuAPI) => {
    const menu = menuAPIToMenu(menuAPI, dispatcher);
    return menu;
  });
  return mainMenus;
};

export const generateHeaderModel = (
  dispatcher: BehaviorSubject<any>,
  settingsMenuList?: IMenuApiModel[],
  accountTextInline?: string
): IHeaderModel<any> => {
  const headerModel: IHeaderModel<any> = {
    logo: 'assets/img/logo-enel-colors.png',
    // sublogo: 'assets/img/logo-sdm.png',
    logoText: 'FUNCIONARIO',
    menus: [
      // {
      //   icon: Icon.map_w,
      //   action: RouteNamesEnum.MapViewer,
      //   dispatcher,
      //   alt: 'Mapa',
      //   isVisible: true,
      //   actionType: ActionType.Route,
      // },
      // {
      //   icon: Icon.clean_map,
      //   action: 'ClearMap',
      //   dispatcher,
      //   alt: 'limpiar Mapa',
      //   isVisible: true,
      //   actionType: ActionType.Map,
      // },
      {
        icon: Icon.platforms,
        text: 'Plataformas',
        alt: 'Plataformas',
        dispatcher,
        isVisible: true,
        subMenu: [
          {
            icon: Icon.tm_logo,
            text: 'Transmilenio',
            alt: 'Transmilenio',
            dispatcher,
            isVisible: true,
            actionType: ActionType.Modal,
            url: 'https://portalqa-cdeg.transmilenio.gov.co/map/dashboard',
          },
          {
            icon: Icon.logo_sit,
            text: 'SIT Bogotá',
            alt: 'SIT Bogotá',
            dispatcher,
            isVisible: true,
            actionType: ActionType.Modal,
            url: 'https://sitbogota.com',
          },
                    {
            icon: Icon.sisem_logo,
            text: 'SISEM',
            alt: 'SISEM',
            dispatcher,
            isVisible: true,
            actionType: ActionType.Modal,
            url: 'https://qa.sisembogota.com/auth',
          },
        ],
      },

      {
        icon: Icon.HeaderNotificationsIcon,
        component: NotificationMenuComponent,
        dispatcher,
        text: 'Notificaciones',
        alt: 'Notificaciones',
        statefulComponent: true,
        isVisible: true,
      },
      // { TODO: remove, it contains the panel, might be required in the future
      //   icon: Icon.HeaderNotificationsIcon,
      //   text: 'Notificaciones',
      //   alt: 'Notificaciones2',
      //   dispatcher,
      //   action: {
      //     returnMap: true,
      //     returnAction: RouteNamesEnum.MapViewer,
      //     action: 'notifications'
      //   } as IMenuEvent,
      //   isVisible: true,
      //   actionType: ActionType.Panel,
      // },
      {
        icon: Icon.assignment,
        action: RouteNamesEnum.Reports,
        actionType: ActionType.Route,
        dispatcher,
        alt: 'Reportes',
        isVisible: true,
        url: '',
        requiredRole: [IRole.VISUALIZADOR, IRole.ADMIN, IRole.CONFIGURACION],
      },
      {
        icon: Icon.dashboard_white,
        actionType: ActionType.Modal,
        dispatcher,
        alt: 'Tableros',
        isVisible: true,
        url: '',

        subMenu: [
          {
            icon: Icon.capacity_y,
            actionType: ActionType.Modal,
            actionPanel: RouteNamesEnum.MapViewer,
            dispatcher,
            alt: 'Aforo',
            text: 'Aforo',
            isVisible: true,
            url: 'https://sit-enel.de.qlikcloud.com/single/?appid=27bc25ab-e826-4aec-a684-58098a3ccca7&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          },
          {
            icon: Icon.AirQuality_Y,
            actionType: ActionType.Modal,
            actionPanel: RouteNamesEnum.MapViewer,
            dispatcher,
            alt: 'Calidad del Aire',
            text: 'Calidad del Aire',
            isVisible: true,
            url: 'https://sit-enel.de.qlikcloud.com/single/?appid=05d176ba-641b-4389-8c63-b7e5812068d2&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          },
          {
            icon: Icon.AirQualityTime,
            actionType: ActionType.Modal,
            actionPanel: RouteNamesEnum.MapViewer,
            dispatcher,
            alt: 'Calidad del Aire 24 Horas',
            text: 'Calidad del Aire 24 Horas',
            isVisible: true,
            url: 'https://sit-enel.de.qlikcloud.com/single/?appid=c6f04085-8397-4e4a-b01f-a3ee1e54a5d9&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          },
          // {
          //   icon: Icon.incidents_y,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Situaciones',
          //   text: 'Situaciones',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=ad665093-231c-436f-a028-7818f27d673b&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.plate_y,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'LPR Placas',
          //   text: 'LPR Placas',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=a3652f24-81dc-4367-a0f8-52c2750c212d&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.incidents_24,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Situaciones 24 Horas',
          //   text: 'Situaciones 24 Horas',
          //   isVisible: true,
          //   url: 'https://sdmc.us.qlikcloud.com/single/?appid=516fcb66-d723-45d0-a3b7-c9da9f2d1e8a&sheet=c0711c2a-7a69-40a6-ac47-baa90410d02d&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.matrix,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Matriz OD',
          //   text: 'Matriz OD',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=278c6f39-0a48-4616-b71c-40cf6765b37d&sheet=9be7ec51-29d9-4f74-8315-bb540018231a&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.camera_OD,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Matrices O-D LPR',
          //   text: 'Matrices O-D LPR',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=4cf23617-c5e0-4d79-b93b-e2f604173a30&sheet=9be7ec51-29d9-4f74-8315-bb540018231a&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.parking_y,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Parking regulado',
          //   text: 'Parking regulado',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=d3740fa3-cc47-4f69-ac92-b9d49dad2717&sheet=7c66131c-5d5b-45fb-b757-2c725b2fd981&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.parking_carga_y,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Parking Zonas de Carga y Descarga',
          //   text: 'Parking Zonas de Carga y Descarga',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=0e634952-09d0-44ae-b496-2eeddf4b84d0&sheet=7c66131c-5d5b-45fb-b757-2c725b2fd981&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.underground_parking,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Parking Subterráneo',
          //   text: 'Parking Subterráneo',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=ea0d13dc-f860-445f-b4c3-d58b7f7890c7&sheet=7c66131c-5d5b-45fb-b757-2c725b2fd981&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.traffic_y,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Tráfico',
          //   text: 'Tráfico',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=2dc0fc06-1c8b-49f2-8e2a-53d992d8c5af&sheet=7a8982af-3249-4b4e-8c7c-ea55fac56d4d&theme=sense&opt=ctxmenu,currsel'
          // },
          // {
          //   icon: Icon.traffic_24,
          //   actionType: ActionType.Modal,
          //   actionPanel: RouteNamesEnum.MapViewer,
          //   dispatcher,
          //   alt: 'Tráfico 24 Horas',
          //   text: 'Tráfico 24 Horas',
          //   isVisible: true,
          //   url: 'https://almeria-sitbi.de.qlikcloud.com/single/?appid=f6beb726-1728-460f-87df-ef935f3ee8a6&sheet=7a8982af-3249-4b4e-8c7c-ea55fac56d4d&theme=sense&opt=ctxmenu,currsel'
          // },

        ]



      },

      // {
      //   icon: Icon.HeaderNotificationsIcon,
      //   text: 'Notificaciones',
      //   alt: 'Notificaciones',
      //   returnPanel: false,
      //   actionPanel: null,
      //   dispatcher,
      //   action: 'notifications',
      //   isVisible: true,
      //   actionType: ActionType.Panel,
      // },
      {
        icon: Icon.settings_w,
        text: 'CONFIGURACIÓN',
        action: 'settings',
        dispatcher: undefined,
        alt: 'Configuración',
        subMenu: settingsMenuList
          ? generateSubmenus(settingsMenuList, dispatcher)
          : undefined,
      },
      {
        textInline: accountTextInline,
        icon: Icon.account_w,
        action: 'close_session',
        dispatcher,
        alt: 'Sesión',
        subMenu: [
          {
            icon: Icon.lock_reset,
            text: 'Cambiar Contraseña',
            alt: 'Cambiar Contraseña',
            action: MenuEventType.change_pass,
            dispatcher,
            isVisible: true,
            actionType: ActionType.Modal,
            data: modals[ModalType.ChangePassword],
          },
          {
            icon: Icon.logout,
            text: 'Cerrar Sesión',
            alt: 'Cerrar Sesión',
            action: RouteNamesEnum.Login,
            dispatcher,
            isVisible: true,
            actionType: ActionType.Route,
          },
        ],
        isVisible: true,
      },
    ],
  };
  return headerModel;
};
